import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

interface LegacyBillingRedirectProps {
  path: 'claim' | 'encounter';
  suffix?: string;
}

export const LegacyBillingRedirect: React.FC<LegacyBillingRedirectProps> = ({
  path,
  suffix = '',
}) => {
  const params = useParams();
  const id = path === 'claim' ? params.claimId : params.encounterId;
  return <Navigate to={`/jotbill/${path}/${id}${suffix}`} replace />;
};
